import React from "react";
import { motion } from "framer-motion";
import { useTheme } from "../../context/ThemeContext";

const CTA = () => {
  const { currentTheme } = useTheme();
  
  return (
    <section className={`py-20 px-6 bg-gradient-to-r ${currentTheme.colors.primary} text-white`}>
      <div className="max-w-4xl mx-auto text-center">
        <motion.h2 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-4xl md:text-5xl font-bold mb-6"
        >
          Your Music Deserves to Be Heard
        </motion.h2>
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="space-y-4 text-xl md:text-2xl mb-10 text-gray-200"
        >
          <p>If you've waited long enough...</p>
          <p>If music still lives inside you...</p>
          <p>If you're ready to stop consuming and start creating...</p>
        </motion.div>
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="flex flex-col sm:flex-row gap-4 justify-center items-center"
        >
          <motion.button 
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => window.open('/zoom', '_blank')}
            className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-4 px-8 rounded-lg text-lg transition-all shadow-2xl"
          >
            👉 Start Your Journey Today
          </motion.button>
          <motion.button 
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => window.open('/zoom', '_blank')}
            className="bg-white text-purple-900 hover:bg-gray-100 font-bold py-4 px-8 rounded-lg text-lg transition-all shadow-2xl"
          >
            👉 Register for Free Webinar
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;
